import React from "react";

// Reference uses the front (user site) images here: front/img/winner.png, front/img/cards/*
const BASE = import.meta.env.BASE_URL;
const FRONT_CARDS = `${BASE}assets/front/img/cards`;

function Fighter({ name, card, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={`${BASE}img/winner.png`} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>{" "}
          <div className="casino-result-cards-item">
            <img src={`${FRONT_CARDS}/${card}.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 1 Card Meter (cmeter1): Fighter A | Fighter B cards
 * (trophy before the winner), rdesc "winner#points" → Winner / Points.
 */
export default function Cmeter1ResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const win = String(t1?.win ?? "");
  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <Fighter name="Fighter A" card={cards[0]} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <Fighter name="Fighter B" card={cards[1]} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Points</div> <div>{desc[1]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
